export default __webpack_public_path__ + "static/media/MyID.0849f88b.svg";